import { FirmWareUpdatingDataActionTypes, FirmWareUpdatingDataActions } from '../actions/firm-ware-updating-data.actions';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {concatMap, debounce, catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of, timer} from 'rxjs';
import {Update} from '@ngrx/entity';
import {updateInfoType} from '../../../shareModel';
import * as featureActions from '../../index';
import * as fromStore from '../../../store';
import {Store, select, Action} from '@ngrx/store';
import {FirmWareService} from '../../../services/firm-ware.service';
import {FirmWareLogParams} from '../../firm-ware/firm-ware.model';


@Injectable()
export class FirmWareUpdatingDataEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private firmWreService = inject(FirmWareService);

  constructor() {}

  getFirmWareUpdatingDatas$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FirmWareUpdatingDataActionTypes.GetFirmWareUpdatingDatas),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params: FirmWareLogParams = {
        otp: user.otp,
        acode: user.acode,
        Status: 0 // Updating
      };
      if (action.payload !== null && action.payload.regionIds) {
        params.RegionIds = action.payload.regionIds;
      }
      return this.firmWreService.ReadFirmwareLog(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            if (res.msg.body.length > 0) {
              // 第二次讀取時，直接讀取第一次回傳的資料。
              params.IdList = res.msg.body.map(i => i.Id);
              params.Status = null;

              return [new featureActions.LoadFirmWareUpdatingDatas(res.msg.body),
                 new featureActions.GetDelayFirmWareUpdatingDatas(params)];
            }
            return [new featureActions.LoadFirmWareUpdatingDatas(res.msg.body)];
          } else {
            return [new featureActions.ClearFirmWareUpdatingDatas()];
          }
        }), catchError(error => {
          return of(new featureActions.ClearFirmWareUpdatingDatas());
        })
      );
    })
  ));
  getDelayFirmWareUpdatingDatas$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FirmWareUpdatingDataActionTypes.GetDelayFirmWareUpdatingDatas),
    map((action: featureActions.GetDelayFirmWareUpdatingDatas) => action.payload),
    debounce(() => timer(60000)),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const requestPayload = { ...payload, otp: user.otp, acode: user.acode };
      return this.firmWreService.ReadFirmwareLog(requestPayload).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            if (res.msg.body.length > 0 && res.msg.body.filter(i => i.Status === 0).length > 0) {
              const updatedPayload = { ...requestPayload, IdList: res.msg.body.map(i => i.Id) };
              return [new featureActions.LoadFirmWareUpdatingDatas(res.msg.body),
              new featureActions.GetDelayFirmWareUpdatingDatas(updatedPayload)];
            }
            return [new featureActions.LoadFirmWareUpdatingDatas(res.msg.body)];
          } else {
            return [new featureActions.ClearFirmWareUpdatingDatas()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.ClearFirmWareUpdatingDatas(), new featureActions.GetFirmWareUpdatingDatas());
        })
      );
    })
  ));

}

